import { apiFetch, API_BASE } from '../api/client'

// Fetch once so poster and seasonal popup share one RP date source.
export async function fetchCurrentGameDate() {
  try {
    const resp = await apiFetch(`${API_BASE}/game/date/current`)
    if (!resp.ok) return null
    const body = await resp.json()
    if (!body.success) return null
    return body.data || null
  } catch {
    return null
  }
}

export async function fetchCurrentMonth() {
  return (await fetchCurrentGameDate())?.month ?? null
}

// Mirrors the seasons seed in PR_API/datas/db_schemas/weather_engine.sql:
// north/equator follow the standard calendar, south is offset by 6 months.
export function getSeason(hemisphere, month) {
  if (!month) return null
  if (hemisphere === 'south') {
    if ([6, 7, 8].includes(month)) return 'Hiver'
    if ([9, 10, 11].includes(month)) return 'Printemps'
    if ([12, 1, 2].includes(month)) return 'Été'
    return 'Automne'
  }
  if ([12, 1, 2].includes(month)) return 'Hiver'
  if ([3, 4, 5].includes(month)) return 'Printemps'
  if ([6, 7, 8].includes(month)) return 'Été'
  return 'Automne'
}
